import React from 'react';

const WORD_CHAR = '[\\p{L}\\p{N}]';

const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Подсвечивает в тексте слова, совпавшие с запросом: API присылает их в исходном написании */
export const Highlight: React.FC<{text: string; words: readonly string[]}> = ({text, words}) => {
	if (!words.length) return <>{text}</>;
	// длинные слова раньше коротких, чтобы «огненным» не подсветилось как «огнен»; только целые слова
	const alternatives = [...words]
		.sort((a, b) => b.length - a.length)
		.map(escapeRegExp)
		.join('|');
	const parts = text.split(new RegExp(`(?<!${WORD_CHAR})(${alternatives})(?!${WORD_CHAR})`, 'giu'));
	// у split с группой захвата совпадения стоят на нечётных местах
	return <>{parts.map((part, index) => (index % 2 ? <mark key={index}>{part}</mark> : part))}</>;
};
